var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgPlusIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.667 17H19v-6.667a.333.333 0 0 0-.333-.333h-1.334a.333.333 0 0 0-.333.333V17h-6.667a.333.333 0 0 0-.333.333v1.334c0 .184.15.333.333.333H17v6.667c0 .184.15.333.333.333h1.334c.184 0 .333-.15.333-.333V19h6.667c.184 0 .333-.15.333-.333v-1.334a.333.333 0 0 0-.333-.333z",
    fill: "#AEAEBD",
    fillRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPlusIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/plusIcon.87d5cc5e.svg";
export { ForwardRef as ReactComponent };